import { motion } from "motion/react";

export function ResearchCard({ icon, title, subtitle, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{
        duration: 0.7,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      whileHover={{ scale: 1.02 }}
      className="relative flex flex-col items-start p-6 md:p-8 rounded-2xl bg-gradient-to-br from-white/5 to-transparent item-border border-white/10 backdrop-blur-sm"
    >
      <div className="flex gap-3 items-center w-full">
        {icon}
        <div className="flex-1">
          <h4 className="text-white text-lg md:text-xl lg:text-2xl">{title}</h4>
          {subtitle && (
            <p className="text-gray-400 text-sm md:text-base mt-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </motion.div>
  );
}
